import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { alpha } from "@mui/material/styles";
export function PortalEmptyState({ icon, title, hint, action, }) {
    return (_jsxs(Box, { sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            px: 2,
            py: { xs: 4, sm: 5 },
        }, children: [_jsx(Box, { sx: (theme) => ({
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 44,
                    height: 44,
                    borderRadius: "50%",
                    mb: 1.5,
                    color: alpha(theme.palette.text.secondary, 0.85),
                    backgroundColor: alpha(theme.palette.primary.main, 0.07),
                }), children: icon }), _jsx(Typography, { variant: "body2", sx: { fontWeight: 600 }, children: title }), hint ? (_jsx(Typography, { variant: "caption", sx: { color: "text.secondary", mt: 0.5, maxWidth: 280 }, children: hint })) : null, action ? _jsx(Box, { sx: { mt: 2 }, children: action }) : null] }));
}
